// /* eslint-disable jsx-a11y/anchor-is-valid */
// import React from "react";
// import { Switch, Redirect } from "react-router-dom";
// import { ContentRoute } from "../../../../_metronic/layout";
// import Login from "./Login";
// import "../../../../_metronic/_assets/sass/pages/login/classic/login-1.scss";

// export function AuthPage() {
//   return (
//     <>
//     <div className="d-flex flex-column flex-root">
//       {/*begin::Login*/}
//       <div
//           className="login login-1 login-signin-on d-flex flex-column flex-lg-row flex-row-fluid bg-white"
//           id="kt_login"
//       >
       
//         <div className="flex-row-fluid d-flex flex-column position-relative p-7 overflow-hidden" style={{backgroundColor: "#263787"}}>
          
//           <div className="d-flex flex-column-fluid flex-center mt-30 mt-lg-0" style={{backgroundColor: "#263787"}}>
//             <Switch>
//             <ContentRoute path="/auth/login" component={Login}/>
//             <Redirect from="/auth" exact={true} to="/auth/login"/>
//             <Redirect to="/auth/login"/>
//           </Switch>
//           </div>
//           <div
//               className="d-flex d-lg-none flex-column-auto flex-column flex-sm-row justify-content-between align-items-center mt-5 p-5">
//           </div>
//         </div>
//       </div>
//     </div>
//   </>
//   );
// }




/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import Card from "react-bootstrap/esm/Card";
import { useFormik, Field, Formik, Form } from "formik";
import * as Yup from "yup";
import { Switch, Redirect, useLocation } from "react-router-dom";
import { ContentRoute } from "../../../../_metronic/layout";
import Login from "./Login";
import { useSelector } from "react-redux";
import "../../../../_metronic/_assets/sass/pages/login/classic/login-1.scss";
import { LayoutSplashScreen } from "../../../../_metronic/layout";
import { withRouter } from "react-router-dom";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";
import { useHistory } from "react-router-dom";

import qs from "qs";
import axios from "axios";
import { connect } from "react-redux";
import * as auth from "../_redux/authRedux";
// import { getRole, getUserByToken, login, getJabatan } from "../_redux/authCrud";
import { RadioJabatan } from "../../../helpers";
import { ssoCheckCode } from "../../../references/Api";

export function AuthPage(props) {
  const {CLIENT_ID, CLIENT_SECRET} = window.ENV;
  const { auth } = useSelector((state) => state.auth);
  const { LOCAL_URL, SSO_URL, BACKEND_URL, SSO_CHECK_CODE } = window.ENV;
  const [showForm, setShowForm] = useState(true);
  const [jabatan, setJabatan] = useState([]);
  const [tok, setTok] = useState("");
  const [loading, setLoading] = useState(true);
  const history = useHistory();


  // const useQuery = () => {
  // return new URLSearchParams(useLocation().search);

  // }
  // const query = useQuery();
  // const code = query.get("code");
  //   const checkCode = () => {
  //   if (code) {
  //     return <AuthPage code={code} />;
  //   } else {
  //     return (window.location.href = `${SSO_URL}/oauth/authorize?client_id=${CLIENT_ID}&response_type=code&redirect_url=${LOCAL_URL}/auth/login`);
  //   }
  // };
  const initValues = {
    token: tok,
    jabatan: "",
    tipeJabatan: "",
  };
  const ProposalEditSchema = Yup.object().shape({
    jabatan: Yup.string().required("Jabatan is required"),
  });
  const choice = jabatan
    ? [...new Map(jabatan.map((m) => [m.unit_name, m])).values()].map((dt) => ({
        name:
          dt.jabatan_name +
          // dt.jabatan_name.slice(0, 6) +
          " " +
          dt.unit_name +
          " " +
          dt.kantor_name +
          ` (${dt.tipeJabatan_name})`,
        value: dt.jabatanPegawai_iri,
        tipeJabatan: dt.tipeJabatan_name,
      }))
    : null;

  // const str = "sitpp:sitpp";
  const str = `${CLIENT_ID}:${CLIENT_SECRET}`;
  const pass = btoa(str);
  const [token, setToken] = useState("");

  const data = {
    grant_type: "authorization_code",
    code: props.code,
    // redirect_uri: `${REACT_APP_LOCAL_URL}/auth/login`,
    redirect_uri: `${LOCAL_URL}/auth/login`,
  };

  const config = {
    headers: {
      "Content-type": "application/x-www-form-urlencoded",
      Authorization: `Basic ${pass}`,
    },
  };
  // const config = {
  //   auth: {
  //     username: CLIENT_ID,
  //     password: CLIENT_SECRET,
  //   },
  // };

  const dataClient = {
    clientId: CLIENT_ID,
    clientSecret: CLIENT_SECRET,
    token,
  };


  // const postCodeToSso = async () => {
  //   try {
  //     return await axios.post(
  //       // `${SSO_CHECK_CODE}`, // Ensure this URL is correct
  //       `/account/oauth/token`,
  //       qs.stringify(data),
  //       config
  //     );
  //   } catch (error) {
  //     console.error("Error posting to SSO:", error.response ? error.response.data : error.message);
  //     throw error; // Rethrow the error if needed
  //   }
  // };

  //Check access_token to SSO, and you will get token IAM
  // const checkToken = async () => {
  //   return await axios.post(
  //     `/account/oauth/check_token`,
  //     // `${REACT_APP_SSO_URL}/oauth/check_token`,
  //     qs.stringify(dataClient),
  //     config
  //   );
  // };

  const postCodeToSso = async () => {
    try {
      return await axios.get(
        // `${SSO_CHECK_CODE}`, // Ensure this URL is correct
        `/auth/cek?code=${props.code}`
      );
    } catch (error) {
      console.error("Error posting to SSO:", error.response ? error.response.data : error.message);
      throw error; // Rethrow the error if needed
    }
  };
  const checkToken = async () => {
    return await axios.get(
      `/auth/cek-token?token=${token}`
    );
  };


  
  useEffect(() => {
    if (auth !== undefined) {
      const response = checkToken();
      response
        .then(({ data, status }) => {
          if (status === 200) {
            props.setNpwp(data.user_name)
            props.setRole(data.authorities);
          }
        })
        .catch((e) => {
          console.log(e);
          // history.push("/logout");
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [auth]);
 
  useEffect(() => {
    let isMounted = true; // Track if the component is mounted
    const response = postCodeToSso(props.code);
    response
      .then(({ data: { access_token } }) => {
        if (isMounted) { // Only update state if mounted
          setToken(access_token);
          props.sso(access_token);
          props.setSso(access_token);
        }
        // console.log(data)
      })
      .catch((e) => {
        console.log(e);
        // history.push("/logout");
      });
    
    return () => { isMounted = false; }; // Cleanup function to set isMounted to false
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  return (
    <>
      {loading ? (
        <LayoutSplashScreen />
      ) : (
        <div className="d-flex flex-column flex-root">
          <div
            className="login login-1 login-signin-on d-flex flex-column flex-lg-row flex-row-fluid bg-white"
            id="kt_login"
          >
            <div
              className="flex-row-fluid d-flex flex-column position-relative p-7 overflow-hidden"
              style={{ backgroundColor: "#263787" }}
            >
              <div
                className="d-flex flex-column-fluid flex-center mt-30 mt-lg-0"
                style={{ backgroundColor: "#263787" }}
              >
                <div>
                  {/* begin::Head */}
                  <Card style={{ borderRadius: "2.5rem" }}>
                    <div
                      className="text-center mb-1 mb-lg-10"
                      style={{ marginTop: "2.4rem" }}
                    >
                      <img
                        src={toAbsoluteUrl("/media/logos/DJP.png")}
                        alt="DJP logo"
                      />
                    </div>
                    <div className="text-center mb-2 mb-lg-80">
                      <h3 className="font-size-h1">LOGIN SEBAGAI :</h3>
                    </div>

                    <Card.Body>
                      <Formik
                        enableReinitialize={true}
                        initialValues={initValues}
                        validationSchema={ProposalEditSchema}
                        onSubmit={(values) => {
                          // props.setJabatan(values.tipeJabatan);
                          // getUserByToken(values.token, values.jabatan).then(
                          //   ({ data }) => {
                          //     props.fulfillUser(data.data);
                          //   }
                          // );
                          // console.log(values)
                        }}
                      >
                        {({
                          handleSubmit,
                          setFieldValue,
                          handleBlur,
                          handleChange,
                          errors,
                          touched,
                          values,
                          isValid,
                        }) => {
                          return (
                            <>
                              <Form className="form form-label-right">
                                <div className="form-group row">
                                  <div className="col-lg-12 col-xl-12">
                                    {choice.map((data, index) => (
                                      <Field
                                        name="jabatan"
                                        component={RadioJabatan}
                                        type="radio"
                                        value={data.value}
                                        key={index}
                                        content={data.name}
                                        jabatan={data.tipeJabatan}
                                      />
                                    ))}
                                  </div>
                                </div>
                                <div className="text-center">
                                  <button
                                    id="kt_login_signin_submit"
                                    type="submit"
                                    className={`btn btn-primary font-weight-bold px-9 py-4 my-3`}
                                    style={{
                                      backgroundColor: "#263787",
                                      borderColor: "#263787",
                                    }}
                                  >
                                    <span>SUBMIT</span>
                                  </button>
                                </div>
                              </Form>
                            </>
                          );
                        }}
                      </Formik>
                    </Card.Body>
                  </Card>
                  <div
                    className="text-dark-50 order-2 order-sm-1 my-2"
                    style={{ textAlign: "center" }}
                  >
                    Copyright &copy; 2021 Direktorat Jenderal Pajak
                  </div>
                </div>
              </div>
              <div className="d-flex d-lg-none flex-column-auto flex-column flex-sm-row justify-content-between align-items-center mt-5 p-5"></div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default withRouter(connect(null, auth.actions)(AuthPage));

